import { ensure, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useAssetsApi } from "../../../../../common/api/master-api/assets/useAssetsApi";
import { ConformingCloudAsset } from "../../../../api/GetConformingCloudAssetsResponse";
import { CloudAssetQueryKey } from "../CloudAssetQueryKey";

export const useConformingCloudAssets = (assetId?: string): SprintQueryResult<ConformingCloudAsset[]> => {
    const { getConformingCloudAssets } = useAssetsApi();

    return useSprintQuery<ConformingCloudAsset[]>({
        queryKey: [CloudAssetQueryKey.ConformingCloudAssets, assetId],
        queryFn: async (): Promise<ConformingCloudAsset[]> => {
            ensure(assetId, "Asset ID is required to fetch conforming cloud assets.");

            const response = await getConformingCloudAssets({ assetId });

            return response.assets;
        },
        options: {
            cacheTime: 0
        }
    });
};
